// 9fbef606107a605d69c0edbcd8029e5d
import {
  CARTPAGE_ACTION_PATTERN,
  NON_CACHED_CART_ACTION_PATTERN,
} from '../../../../constants/reducer.constants';

const BAGPAGE_CONSTANTS = {
  GET_CACHED_CART_DATA_COMPLETED: 'GET_CACHED_CART_DATA_COMPLETED',
  IS_PLCC_IC_ADDRESS_MODAL_OPEN: 'IS_PLCC_IC_ADDRESS_MODAL_OPEN',
  GET_NON_CACHED_CART_DATA_COMPLETED: 'GET_NON_CACHED_CART_DATA_COMPLETED',
  GET_ORDER_DETAILS: 'GET_ORDER_DETAILS',
  GET_CART_DATA: 'GET_CART_DATA',
  GET_CACHED_CART_DATA: `${CARTPAGE_ACTION_PATTERN}GET_CACHED_CART_DATA`,
  GET_NON_CACHED_CART_DATA: `${NON_CACHED_CART_ACTION_PATTERN}GET_NON_CACHED_CART_DATA`,
  GET_CART_DATA_SEQUENTIALLY: `GET_CART_DATA_SEQUENTIALLY`,
  FETCH_CART_DATA: 'FETCH_CART_DATA',
  GET_ORDER_DETAILS_COMPLETE: 'GET_ORDER_DETAILS_COMPLETE',
  GET_ORDER_DETAILS_PARTIAL: 'GET_ORDER_DETAILS_PARTIAL',
  UPDATE_PAYPAL_STATUS: 'UPDATE_PAYPAL_STATUS',
  SET_COUPONS_DATA: 'SET_COUPONS_DATA',
  SET_COUPONS_DATA_FOR_HOME_CAROUSEL: 'SET_COUPONS_DATA_FOR_HOME_CAROUSEL',
  SET_BAG_PAGE_ERRORS: 'SET_BAG_PAGE_ERRORS',
  FETCH_MODULEX_CONTENT: 'FETCH_MODULEX_CONTENT_BAGPAGE',
  SET_MODULEX_CONTENT: 'ADD_MODULEX_CONTENT_BAGPAGE',
  START_BAG_CHECKOUT: 'START_BAG_CHECKOUT',
  SET_ITEM_OOS: 'SET_ITEM_OOS',
  SET_ITEM_UNAVAILABLE: 'SET_ITEM_UNAVAILABLE',
  SET_ITEM_AVAILABLE: 'SET_ITEM_AVAILABLE',
  SET_ITEMS: 'SET_ITEMS',
  AUTHORIZATION_PAYPAL_CHECKOUT: 'AUTHORIZATION_PAYPAL_CHECKOUT',
  START_PAYPAL_CHECKOUT: 'START_PAYPAL_CHECKOUT',
  START_APPLE_PAY_CHECKOUT: 'START_APPLE_PAY_CHECKOUT',
  START_PAYPAL_NATIVE_CHECKOUT: 'START_PAYPAL_NATIVE_CHECKOUT',
  OPEN_CHECKOUT_CONFIRMATION_MODAL: 'OPEN_CHECKOUT_CONFIRMATION_MODAL',
  FETCHING_CART_DATA: 'FETCHING_CART_DATA',
  FETCHING_NON_CACHE_DATA: 'FETCHING_NON_CACHE_DATA',
  CLOSE_CHECKOUT_CONFIRMATION_MODAL: 'CLOSE_CHECKOUT_CONFIRMATION_MODAL',
  REMOVE_UNQUALIFIED_AND_CHECKOUT: 'REMOVE_UNQUALIFIED_AND_CHECKOUT',
  CART_ITEMS_SET_UPDATING: 'CART_ITEMS_SET_UPDATING',
  ROUTE_FOR_CART_CHECKOUT: 'ROUTE_FOR_CART_CHECKOUT',
  ADD_ITEM_SAVE_FOR_LATER: 'ADD_ITEM_SAVE_FOR_LATER',
  CART_ITEMS_SET_SFL: 'CART_ITEMS_SET_SFL',
  CART_ITEMS_SET_SFL_ERROR: 'CART_ITEMS_SET_SFL_ERROR',
  OPEN_ITEM_DELETE_CONFIRMATION_MODAL: 'OPEN_ITEM_DELETE_CONFIRMATION_MODAL',
  CLOSE_ITEM_DELETE_CONFIRMATION_MODAL: 'CLOSE_ITEM_DELETE_CONFIRMATION_MODAL',
  ITEM_SFL_SUCCESS_MSG_TIMEOUT: 60 * 50,
  ITEM_BAG_DELETE_MSG_TIMEOUT: 50 * 40,
  PAYPAL_WEBVIEW_ENABLE: 'PAYPAL_WEBVIEW_ENABLE',
  IS_PAYPAL_BUTTON_RENDER_DONE: 'IS_PAYPAL_BUTTON_RENDER_DONE',
  IS_PAYPAL_LIBRARY_RENDER_DONE: 'IS_PAYPAL_LIBRARY_RENDER_DONE',
  RESET_BAG_LOADING_STATE: 'RESET_BAG_LOADING_STATE',
  GET_SFL_DATA: 'GET_SFL_DATA',
  SET_SFL_DATA: 'SET_SFL_DATA',
  SET_CART_SFL_MERGED: 'SET_CART_SFL_MERGED',
  SET_TRANSLATED_SFL_DATA: 'SET_TRANSLATED_SFL_DATA',
  BAG_STATE: 'BAG',
  SFL_STATE: 'SFL',
  SFL_ITEMS_DELETE: 'SFL_ITEMS_DELETE',
  SFL_ITEMS_MOVE_TO_BAG: 'SFL_ITEMS_MOVE_TO_BAG',
  SFL_ITEMS_SET_DELETED: 'SFL_ITEMS_SET_DELETED',
  BAG_ITEMS_SET_DELETED: 'BAG_ITEMS_SET_DELETED',
  RESET_CART_DATA: 'RESET_CART_DATA',
  CART_DATA_RECEIVED: 'CART_DATA_RECEIVED',
  CART_DATA_NOT_RECEIVED: 'CART_DATA_NOT_RECEIVED',
  BAG_PAGE_STICKY_HEADER_INTERVAL: 20 * 100,
  PAYPAL_BUTTON_HIDDEN: 'PAYPAL_BUTTON_HIDDEN',
  RESET_BAG_LOADED_STATE: 'RESET_BAG_LOADED_STATE',
  SET_BAG_LOADED_STATE: 'SET_BAG_LOADED_STATE',
  SET_BAG_PAGE_ROUTING: 'SET_BAG_PAGE_ROUTING',
  UPDATE_SFL_ITEM: 'UPDATE_SFL_ITEM',
  BAG_PAGE: 'bagPage',
  SHOPPING_BAG: 'shopping bag',
  HEADER_CART: 'header-cart',
  SFL_ITEMS_MOVED_TO_BAG: 'SFL_ITEMS_MOVED_TO_BAG',
  UPDATE_AIRMILES_DATA: 'UPDATE_AIRMILES_DATA',
  UPDATE_ADDRESS_IDS: 'UPDATE_ADDRESS_IDS',
  CHECK_PAYPAL_OOS: 'CHECK_PAYPAL_OOS',
  SET_PAYPAL_MODAL_ACTION_OOS: 'SET_PAYPAL_MODAL_ACTION_OOS',
  SET_APPLE_PAY_MODAL_ACTION_OOS: 'SET_APPLE_PAY_MODAL_ACTION_OOS',
  CHECKOUT_REVIEW: 'checkout:review',
  UPDATE_CART_COUNT: 'UPDATE_CART_COUNT',
  CART_SET_ORDER_ID: 'CART_SET_ORDER_ID',
  REMOVE_DELETED_ITEM: 'REMOVE_DELETED_ITEM',
  ADD_DELETED_ITEM_ON_API_FAILURE: 'ADD_DELETED_ITEM_ON_API_FAILURE',
  PAYPAL_SETTINGS_CALL_STATUS: 'PAYPAL_SETTINGS_CALL_STATUS',
  UPDATE_CART_PRICE_DATA: 'UPDATE_CART_PRICE_DATA',
  OPEN_APAY_UNQUALIFIED_ITEMS_MODAL: 'OPEN_APAY_UNQUALIFIED_ITEMS_MODAL',
  UPDATE_MINIBAG_FLAG: 'UPDATE_MINIBAG_FLAG',
  UPDATE_MINIBAG_TIMESTAMP: 'UPDATE_MINIBAG_TIMESTAMP',
  UPDATE_ORDERTYPE_DATA: 'UPDATE_ORDERTYPE_DATA',
  SET_CART_SUPRESS_BAG_UPDATE: 'SET_CART_SUPRESS_BAG_UPDATE',
  SET_MAX_ITEM_ERROR: 'SET_MAX_ITEM_ERROR',
  SET_OOS_ERROR: 'SET_OOS_ERROR',
  SET_VMP_ERROR: 'SET_VMP_ERROR',
  SET_MAX_ITEM_ERROR_DISPLAYED: 'SET_MAX_ITEM_ERROR_DISPLAYED',
  SET_COUPON_MERGE_ERROR: 'SET_COUPON_MERGE_ERROR',
  PROCESS_MUTATION_CACHED_DATA: 'PROCESS_MUTATION_CACHED_DATA',
  PROCESS_MUTATION_NON_CACHED_DATA: 'PROCESS_MUTATION_NON_CACHED_DATA',
  SET_CACHED_DATA_LOADER: 'SET_CACHED_DATA_LOADER',
  SET_NON_CACHED_DATA_LOADER: 'SET_NON_CACHED_DATA_LOADER',
  SET_CACHED_CART_DATA_TTL: 'SET_CACHED_CART_DATA_TTL',
  CLEAR_CACHED_CART_DATA_TTL: 'CLEAR_CACHED_CART_DATA_TTL',
  SET_NON_CACHED_CART_DATA_TTL: 'SET_NON_CACHED_CART_DATA_TTL',
  CLEAR_NON_CACHED_CART_DATA_TTL: 'CLEAR_NON_CACHED_CART_DATA_TTL',
  CACHED_CART_DATA_TTL: 5 * 60 * 1000,
  RESET_CART_CACHE: 'RESET_CART_CACHE',
  RESET_NON_CACHE_BAG_LOADING_STATE: 'RESET_NON_CACHE_BAG_LOADING_STATE',
  UPDATE_CART_LOCAL_DATA: 'UPDATE_CART_LOCAL_DATA',
  UPDATE_CART_COMPLETE: 'UPDATE_CART_COMPLETE',
  SET_PAYMENT_METHOD: 'SET_PAYMENT_METHOD',
  CART_ITEM_QUICK_UPDATE: 'CART_ITEM_QUICK_UPDATE',
  UPDATE_PRICE_DROP_VALUES: 'UPDATE_PRICE_DROP_VALUES',
  UPDATE_PRICE_DROP_VALUES_IN_SFL: 'UPDATE_PRICE_DROP_VALUES_IN_SFL',
  VMP_NAVIGATION_XHR: 'VMP_NAVIGATION_XHR',
  SET_BAG_PAGE_LOADING_STATUS: 'SET_BAG_PAGE_LOADING_STATUS',
  SET_SFL_LIST_ID: 'SET_SFL_LIST_ID',
  GET_ESTIMATED_TAX: 'GET_ESTIMATED_TAX',
  SET_ESTIMATED_TAX: 'SET_ESTIMATED_TAX',
  SET_ZIP_FOR_TAX: 'SET_ZIP_FOR_TAX',
  SET_ZIP_CODE_ERROR: 'SET_ZIP_CODE_ERROR',
  RESET_ZIP_FOR_TAX: 'RESET_ZIP_FOR_TAX',
  RESET_TAX: 'RESET_TAX',
  IS_TOTAL_CALCULATED: 'IS_TOTAL_CALCULATED',
  BAG_PAGE_ROUTING: 'BagPage',
  BUTTON_SPINNER_LOADER: 'BUTTON_SPINNER_LOADER',
  ESTIMATED_TAX_FROM_DEFAULT_ADDRESS: 'ESTIMATED_TAX_FROM_DEFAULT_ADDRESS',
  NON_CACHE_DATA_LOADING: 'NON_CACHE_DATA_LOADING',
  FETCH_INVENTORY_DETAILS: 'FETCH_INVENTORY_DETAILS',
  IS_FROM_ESTIMATED_TAX_FORM: 'IS_FROM_ESTIMATED_TAX_FORM',
  RESET_ESTIMATED_TAX_FROM_DEFAULT_ADDRESS: 'RESET_ESTIMATED_TAX_FROM_DEFAULT_ADDRESS',
  SET_BACKPACK_DELETED_ERROR: 'SET_BACKPACK_DELETED_ERROR',
  START_PLCC_CHECKOUT: 'START_PLCC_CHECKOUT',
  SET_ISPLCCICFIRED: 'SET_ISPLCCICFIRED',
  SET_SUBMIT_BUTTON_STATE: 'SET_SUBMIT_BUTTON_STATE',
  PLCC_SHIPPING_ADDRESS_UPDATE: 'PLCC_SHIPPING_ADDRESS_UPDATE',
  GET_UNQUALIFIED_ITEMS: 'GET_UNQUALIFIED_ITEMS',
  IS_PLCC_IC_PICKUP_MODAL_OPEN: 'IS_PLCC_IC_PICKUP_MODAL_OPEN',
  COUPON_CALCULATE_TAX: 'COUPON_CALCULATE_TAX',
  SHOW_APPLE_PAY_DEFAULT: 'SHOW_APPLE_PAY_DEFAULT',
  START_AFTERPAY_EXPRESS_CHECKOUT: 'START_AFTERPAY_EXPRESS_CHECKOUT',
  SET_AFTERPAY_OPEN: 'SET_AFTERPAY_OPEN',
  SET_BOSS_CART_AVAILABLE: 'SET_BOSS_CART_AVAILABLE',
  SAVE_SHARE_CART: 'SAVE_SHARE_CART',
  SAVE_SHARE_CART_ERROR: 'SAVE_SHARE_CART_ERROR',
  FETCH_SHARE_CART_ERROR: 'FETCH_SHARE_CART_ERROR',
  FETCH_SHARE_CART: 'FETCH_SHARE_CART',
  GET_ORDER_DETAILS_COMPLETE_APPLE_PAY: 'GET_ORDER_DETAILS_COMPLETE_APPLE_PAY',
  SET_DEFAULT_BANNER: 'SET_DEFAULT_BANNER',
  REMOVE_COUPON_FAIL: 'REMOVE_COUPON_FAIL',
  REMOVE_COUPON_SUCCESS: 'REMOVE_COUPON_SUCCESS',
  FREE_SHIPMENT_CODES: ['CGND', 'PGND', 'UGNR', 'PMDC'], // ONLY US and CA standard and ground shipping codes
  TOGGLE_PLCC_LOGIN_MODAL: 'TOGGLE_PLCC_LOGIN_MODAL',
  TOGGLE_QUICK_ADD_MODAL: 'TOGGLE_QUICK_ADD_MODAL',
  QUICK_ADD_MODAL_RECS_TYPE: 'QUICK_ADD_MODAL_RECS_TYPE',
  HAS_SFL_CALL_COMPLETED: 'HAS_SFL_CALL_COMPLETED',
  SET_ADYEN_SESSION_DATA: 'SET_ADYEN_SESSION_DATA',
  SET_ADYEN_SETUP_DATA: 'SET_ADYEN_SETUP_DATA',
  SET_IS_MIXED_PAYMENT_WITH_PAYPAL: 'SET_IS_MIXED_PAYMENT_WITH_PAYPAL',
  SET_ADD_TO_BAG_CALL_MADE: 'SET_ADD_TO_BAG_CALL_MADE',
};

export default BAGPAGE_CONSTANTS;
